import { render, staticRenderFns } from "./Mailto.vue?vue&type=template&id=1dea17f7"
import script from "./Mailto.vue?vue&type=script&lang=js"
export * from "./Mailto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports